<template>
    <drawer title="Content">
        <template v-slot:header-primary>
            <!-- <drawer-search /> -->
        </template>

        <navigation-tree item-type="content">
            <template #meta-content>
                <favorites
                    :recently-edited-pages="recentlyEditedDummyPages"
                    :favorites-list="favoritesDummyList"
                    @selected="onClose"
                />
            </template>
        </navigation-tree>
    </drawer>
</template>

<script>
import { mapMutations } from 'vuex';

import NavigationTree from '@/components/page-editor/navigation-tree/navigation-tree';
import Favorites from '@/components/page-editor/favorites';
import Drawer from '@/components/shared/drawer/drawer';
import { HIDE_DRAWER } from '@/store/types/mutation-types';

export default {
    components: {
        NavigationTree,
        Favorites,
        Drawer,
    },

    data() {
        return {
            // TODO: will need to replace dummy data (used for `favorites.vue`) with real data fetching:
            recentlyEditedDummyPages: [
                { name: 'Software' },
                { name: 'Meeting Room Devices' },
                { name: 'Lifesize' },
                { name: 'Integrations' },
            ],

            favoritesDummyList: [
                { name: 'Integrations' },
                { name: 'Lifesize vs Others' },
                { name: 'Awards' },
            ],
        };
    },

    methods: {
        ...mapMutations({
            hideDrawer: HIDE_DRAWER,
        }),

        onClose() {
            this.hideDrawer();
        },
    },
};
</script>
